import { TranscriptEntry } from '../../../platform-call';
import { createAction } from '../../../store.model';
import { ActionType } from '../transcript-dialog.action';

export interface SelectQuotes {
    quotes: TranscriptEntry[];
    mode?: 'toggle-all' | 'set' | null | undefined;
}

export const selectQuotes = createAction<ActionType, SelectQuotes>(
    ActionType.COACHING_DETAIL__TD__SELECT_QUOTES,
);
